import*as Redux from'redux';import{REQUEST_CORE_CONFIG,RECEIVE_CORE_CONFIG,ERROR_CORE_CONFIG}from"./config.constants";/**
 * Dispatches the REQUEST_CORE_CONFIG action.
 * @return {Object} The REQUEST_CORE_CONFIG action.
 */export var requestConfig=function requestConfig(){return{type:REQUEST_CORE_CONFIG};};/**
 * Dispatches the RECEIVE_CORE_CONFIG action.
 * @param {Object} config config
 * @return {Object} The RECEIVE_CORE_CONFIG action.
 */export var receiveConfig=function receiveConfig(config){return{type:RECEIVE_CORE_CONFIG,config:config};};/**
 * Dispatches the ERROR_CORE_CONFIG action.
 * @param {Error} error error
 * @return {Object} The ERROR_CORE_CONFIG action.
 */export var errorConfig=function errorConfig(error){return{type:ERROR_CORE_CONFIG,error:error};};